import { FederalTaxClassification } from "../types";

export const selectorNo1099 = (taxClassification: FederalTaxClassification) =>
  taxClassification === "CorporationC" ||
  taxClassification === "CorporationS" ||
  taxClassification === "LlcCorporationC" ||
  taxClassification === "LlcCorporationS";
